import React from "react";
import AmlTable from "../AmlTable";
import { Box } from "@mui/material";

const AmlExpired = ({ allAml, handleOpenLegendaModal }) => {
  return (
    <Box sx={{ width: "100%" }}>
      <AmlTable
        data={allAml}
        onStatusInfoClick={handleOpenLegendaModal}
        emptyMessage="Non ci sono aml scaduti"
      />
    </Box>
  );
};

export default AmlExpired;
